export enum OpenChart {
    Performance = "Historical Performance",
    Deposits = "Deposits",
    Borrows = "Borrows",
    Apy = "APY"
}
